module.exports = __webpack_public_path__ + "static/media/louise-16.ebb84520.jpg";